<template>
  <div class="static-page page">
    <div class="sides-padding">
      <div class="static-page__container">
        <h1 class="static-page__title">{{ page.title }}</h1>
        <p class="static-page__title" v-if="page.subtitle">{{ page.subtitle }}</p>
        <div v-if="$options.filters.editor_has_text(page.description)" class="static-page__description">
          <EditorJSComponent :text="page.description" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PAGE from "@/graphql/queries/page.graphql";
import EditorJSComponent from "components/EditorJSComponent.vue";

export default {
  name: "StaticPage",
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: PAGE,
        variables: {
          id: parseInt(route.params.id),
        },
      })
      .then(({ data }) => {
        store.state.static_page = data.page;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  computed: {
    page() {
      return this.$store.state.static_page || {};
    },
  },
  components: {
    EditorJSComponent,
  },
  metaInfo() {
    return {
      title: this.page.meta_title || this.page.title,
      description: this.page.meta_description,
      keywords: this.page.meta_keywords,
    };
  },
};
</script>

<style lang="stylus">
.static-page {
  display grid
  padding 32px 15px 48px
  +below(860px) {
    padding 15px 0
  }

  &__container {
    max-width var(--main_width)
    width 100%
    display grid
    align-items start
    gap 24px
    margin 0 auto
  }

  &__title {
    margin 0
  }
}
</style>
